import React from "react";
import { Link } from "react-router-dom";
import { Lock, Sparkles } from "lucide-react";
import { Button } from "./ui/button";
import { useAuth } from "../context/AuthContext";
import { FREE_WINDOW_DAYS, PRO_WINDOW_DAYS } from "../data/mock";

export const useIsPro = () => Boolean(useAuth()?.user?.pro);

// Blurs children and overlays an upgrade card when `locked` is true.
export default function ProGate({ locked, children, count, className = "", compact = false, title = "Unlock the full year with PRO", description }) {
  if (!locked) return children;
  return (
    <div className={`relative ${className}`} data-testid="pro-gate">
      <div className="pointer-events-none max-h-[70vh] select-none overflow-hidden blur-[6px] [mask-image:linear-gradient(to_bottom,black_60%,transparent)]" aria-hidden="true">{children}</div>
      <div className="absolute inset-0 flex items-start justify-center p-4 sm:items-center">
        <div className={`w-full max-w-md rounded-2xl border border-blue-200 bg-white/95 text-center shadow-2xl shadow-blue-100 backdrop-blur ${compact ? "p-5" : "p-6 sm:p-7"} mt-4 sm:mt-0`}>
          <span className="mx-auto flex h-11 w-11 items-center justify-center rounded-full bg-blue-600 text-white"><Lock className="h-5 w-5" /></span>
          <h3 className="mt-3 text-lg font-extrabold text-slate-900">{title}</h3>
          <p className="mt-1.5 text-sm text-slate-600">
            {description || (
              <>
                {count ? <><span className="font-bold text-slate-900">{count} award seat{count === 1 ? "" : "s"}</span> found beyond the next {FREE_WINDOW_DAYS} days. </> : null}
                Free accounts see the next {FREE_WINDOW_DAYS} days — PRO shows availability up to {PRO_WINDOW_DAYS} days ahead, plus Cabin Compare, alerts and live search.
              </>
            )}
          </p>
          <Link to="/pricing" className="mt-4 block"><Button data-testid="pro-gate-upgrade" className="w-full gap-2 bg-blue-600 font-semibold hover:bg-blue-700"><Sparkles className="h-4 w-4" /> Go PRO — $8.99/mo or $89.90/yr</Button></Link>
          <p className="mt-2 text-[11px] text-slate-400">2 months free on yearly · cancel anytime</p>
        </div>
      </div>
    </div>
  );
}
